import React from 'react';
import {View, StyleSheet,Text } from '@react-pdf/renderer';
import TableHeader from './TableHeader'
import TableRow from './TableRow'
import TableBlankSpace from './TableBlankSpace'
import TableFooterMerchandise from './TableFooterMerchandise'
import { Table } from 'react-bootstrap';

const formatNumber = (number = 0, decimals = 2, prefix = '', sufix = '') => {
  if (isNaN(number) || isNaN(decimals)) { return number; }
  number = Number(number).toFixed(decimals || 0) + "";

  const separador = ','; // separador para los miles
  const sepDecimal = '.'; // separador para los decimales

  let splitStr = number.split('.');
  let splitLeft = splitStr[0];
  let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
  let regx = /(\d+)(\d{3})/;

  while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, "$1" + separador + "$2");
  }
  return prefix + splitLeft + splitRight + sufix;
};

const styles = StyleSheet.create({
    tableContainer: {
        width: '97%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
      backgroundColor: '#e2e2e2',
      display: 'flex',
      flexDirection: 'row',
    },
    headers: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        flexWrap: 'wrap',
        height:24
    },
    text:{
      display: 'flex',
      fontSize:'8px',
      alignSelf:'center',
      fontWeight:'300'
    },
    tableRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    cell: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      fontSize:'8px',
      textAlign: 'center',
      paddingTop: '2px',
      paddingLeft: '2px'
      
    },
    itemcode: {
        minWidth: '15%',
        maxWidth: '15%',
    },
    ean: {
        minWidth: '18%',
        maxWidth: '18%',         
    },
    qty: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    unit: {
        minWidth: '8%',
        maxWidth: '8%'
    },
    description: {
        minWidth: '37%',
        maxWidth: '37%',
    },
    price: {
      minWidth: '15%',
      maxWidth: '15%',
  },
    dicount: {
        minWidth: '7%',
        maxWidth: '7%'
    },
    igv: {
        minWidth: '5%',
        maxWidth: '5%',
    },
    isc: {
        minWidth: '5%',
        maxWidth: '5%',
    },
    total: {
        minWidth: '15%',
        maxWidth: '15%',
    },
});

  const ItemsTableMerchandise = ({items,header,view}) => {
    // let blankRows = Array((items.length + 2) - items.length).fill(0)
    return(
      <View style={styles.tableContainer}> 
        <View style={styles.header} fixed>
          <View style={[styles.headers,styles.itemcode]}>
              <Text style={styles.text}>CÓDIGO ARTÍCULO</Text>
          </View>
          {/* <View style={[styles.headers,styles.ean]}>
              <Text style={styles.text}>CÓDIGO DE BARRAS</Text>
          </View> */}
          <View style={[styles.headers,styles.description]}>
              <Text style={styles.text}>DESCRIPCIÓN</Text>
          </View>
          <View style={[styles.headers,styles.unit]}>
              <Text style={styles.text}>UNIDAD</Text>
          </View>
          <View style={[styles.headers,styles.qty]}>
              <Text style={styles.text}>CANTIDAD</Text>
          </View>
          <View style={[styles.headers,styles.unit]}>
              <Text style={styles.text}>PESO</Text>
          </View>
          <View style={[styles.headers,styles.qty]}>
              <Text style={styles.text}>PESO TOTAL</Text>
          </View>
          <View style={[styles.headers,styles.price]}>
              <Text style={styles.text}>PRECIO</Text>
          </View>
          {/* <View style={[styles.headers,styles.dicount]}>
              <Text style={styles.text}>DSCTO</Text>
          </View> */}
          {/* <View style={[styles.headers,styles.igv]}>
              <Text style={styles.text}>IVA</Text>
          </View> */}
          {/* <View style={[styles.headers,styles.isc]}>
              <Text style={styles.text}>ISC</Text>
          </View> */}
          <View style={[styles.headers,styles.total]}>
              <Text style={styles.text}>TOTAL</Text>
          </View>
        </View>
        {items.map( (item, index) => (
          <View style={styles.tableRow}>
            <View style={[styles.cell,styles.itemcode]}>
                <Text>{item.ItemCode}</Text>
            </View>
            {/* <View style={[styles.cell,styles.ean]}>
                <Text>{`${item.CodeBars || ''}`}</Text>
            </View> */}
            <View style={[styles.cell,styles.description]}>
                <Text>{item.Dscription}</Text>
            </View>
            <View style={[styles.cell,styles.unit]}>
                <Text>{item.UserBaseUn}</Text>
            </View>
            <View style={[styles.cell,styles.qty]}>
                <Text>{Number.parseFloat(item.Quantity).toFixed(2)}</Text>
            </View>
            <View style={[styles.cell, styles.qty, { textAlign: "right" }]}>
                <Text>{formatNumber(item.Weight, 3)}</Text>
            </View>
            <View style={[styles.cell, styles.qty, { textAlign: "right" }]}>
              <Text>{formatNumber(Number(item.Weight || 0) * Number(item.Quantity), 3)}</Text>
            </View>
            <View style={[styles.cell,styles.price]}>
                <Text>{Number.parseFloat(item.Price).toFixed(2)}</Text>
            </View>
            {/* <View style={[styles.cell,styles.dicount]}>
                <Text>{Number.parseFloat(item.Descuento).toFixed(2)}</Text>
            </View> */}
            {/* <View style={[styles.cell,styles.igv]}>
                <Text>{`${Number.parseFloat(item.Impuesto).toFixed(2)}`}</Text>
            </View> */}
            {/* <View style={[styles.cell,styles.isc]}>
                <Text>0</Text>
            </View> */}
            <View style={[styles.cell,styles.total]}>
                <Text>{Number.parseFloat(item.LineTotal).toFixed(2)}</Text>
            </View>
          </View>
        ))}
        <View style={[styles.tableRow]}>
          <View style={[styles.cell,styles.itemcode,{height:'15%'}]}>
            <Text>{''}</Text>
          </View>
          <View style={[styles.cell,styles.ean]}>
            <Text>{''}</Text>
          </View>
          <View style={[styles.cell,styles.qty]}>
            <Text>{''}</Text>
          </View>
          <View style={[styles.cell,styles.unit]}>
            <Text>{''}</Text>
          </View>
          <View style={[styles.cell,styles.description]}>
            <Text>{''}</Text>
          </View>
          <View style={[styles.cell,styles.price]}>
            <Text>{''}</Text>
          </View>
          {/* <View style={[styles.cell,styles.dicount]}>
            <Text>{''}</Text>
          </View> */}
          {/* <View style={[styles.cell,styles.igv]}>
          </View> */}
          {/* <View style={[styles.cell,styles.isc]}>
          </View> */}
          <View style={[styles.cell,styles.total]}>
        </View>
        </View>
        <TableFooterMerchandise header={header} items = {items} view={view}/>         
      </View> 
      
    );
};
  
  export default ItemsTableMerchandise